import { useSpendUserRoleUpdateIsDashboardLegacyMutation } from "graphql/generated";
import { useAppContexts } from "hooks/use-context";
import { useEffect } from "react";
import { SnapLabeledToggle } from "suit";

function LegacyDashboard() {
  const { user, toast } = useAppContexts();

  const [updateLegacyDashboard, { loading, data }] =
    useSpendUserRoleUpdateIsDashboardLegacyMutation();

  useEffect(() => {
    if (!loading && data?.spendUserRoleUpdateIsDashboardLegacy) {
      toast?.setToast({
        message: "Dashboard Setting Updated Successfully",
        type: "success",
      });
      user?._createSession();
    }
    // eslint-disable-next-line
  }, [loading, data,]);

  return (
    <div className="card">
      <h1 className="text-lg font-semibold mb-4">Legacy Dashboard</h1>
      <SnapLabeledToggle
        label="When enabled the legacy dashboard will be shown to your user only."
        onSnap-labeled-toggle-click={(e) => {
          updateLegacyDashboard({
            variables: {
              input: {
                userId: user?._session?.userId!,
                type: user?._session?.role?.name!,
                isEnabled: !user?.isLegacyDashboard(),
              },
            },
          });
        }}
        checked={user?.isLegacyDashboard()}
      />
    </div>
  );
}

export default LegacyDashboard;
